import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { DocumentScoreBlock } from 'src/components/DocumentScoreBlock';
import { useActiveVariationInstanceId } from '../../services';
import { VariationDetails } from './views/VariationDetails';
import { useDocumentVariationsData, useDetailsVariation } from './services';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const DocumentScores = ({ className, parentElement }) => {
  const styles = useStyles();

  const { handleDetailsClick, handleScoreHover } = useHandlers();

  const { variations, boundaries } = useDocumentVariationsData(parentElement);
  const activeInstanceId = useActiveVariationInstanceId();
  const detailsVariation = useDetailsVariation(variations);

  return (
    <div className={cx(styles.root, className)}>
      {variations.map((variation) => (
        <DocumentScoreBlock
          key={variation.instanceId}
          variation={variation}
          boundaries={boundaries[variation.instanceId]}
          onDetailsClick={handleDetailsClick}
          onHover={handleScoreHover}
          expanded={variation.instanceId === activeInstanceId}
        />
      ))}

      {detailsVariation && <VariationDetails variation={detailsVariation} />}
    </div>
  );
};

DocumentScores.propTypes = {
  className: PropTypes.string,
  parentElement: PropTypes.instanceOf(Element).isRequired,
};

DocumentScores.defaultProps = {
  className: '',
};
